export default "__VITE_ASSET__c8606bb9__"